/*!
 * KoliBri - The accessible HTML-Standard
 */
import { g as watchString } from './common-D-vggmh2.js';

const validatePlaceholder = (component, value, options = {}) => {
    watchString(component, '_placeholder', value, options);
};

export { validatePlaceholder as v };
//# sourceMappingURL=placeholder-CmUUN-3U.js.map

//# sourceMappingURL=placeholder-CmUUN-3U.js.map